import React from "react";
import { Message } from "primereact/message";
import { COPY } from "../ThgAnnualSummary.consts";

/** The current year, or a year still in its grace period: computed live, and not to be paid from. */
const ProvisionalBanner: React.FC = () => (
  <Message severity="warn" className="w-full justify-content-start mb-3" text={COPY.provisionalBanner} />
);

export default ProvisionalBanner;
